import{css}from'glamor';var info=css({paddingTop:24}).toString();var element=css({marginTop:16}).toString();export default{info:info,element:element};